import * as api from '../api';
import { getIsFetching } from '../reducers/otherPestsRef';

export const FETCH_ZONE_TEMPLATES = 'intervention.FETCH_ZONE_TEMPLATES';
export const FETCH_ZONE_TEMPLATES_SUCCESS =
  'intervention.FETCH_ZONE_TEMPLATES_SUCCESS';

const requestZoneTemplates = () => ({
  type: FETCH_ZONE_TEMPLATES,
});

const receiveZoneTemplates = zone_templates => ({
  type: FETCH_ZONE_TEMPLATES_SUCCESS,
  zone_templates,
});

export const fetchZoneTemplates = intervention => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestZoneTemplates());

  return api
    .getZoneTemplates(intervention)
    .then(response => dispatch(receiveZoneTemplates(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/actions/zoneTemplatesRef.js